export const STATUS_CANCELADO = 0
export const STATUS_VENCENDO = 1
export const STATUS_SUPERADO = 3
export const STATUS_REPROVADO = 99
export const STATUS_VENCEDOR = 100
